//
import { isUndefined, isPlainObject, isArray, isBoolean, isNull, isSymbol } from './javascript.util'
const localStorage = window.localStorage
const arr = []
const push = arr.push
const splice = arr.splice

function Storage (key, value) {
  return new Storage.prototype.Init(key, value)
}
Storage.fn = Storage.prototype = {
  constructor: Storage,
  cacheKyes: '',
  Init (key, value) {
    this.cacheKyes = key
    // 取
    if (isUndefined(value)) {
      const currentData = localStorage.getItem(key)
      try {
        this[this.cacheKyes] = JSON.parse(currentData)
      } catch (error) {
        this[this.cacheKyes] = currentData
      }
    } else if (!isUndefined(value)) {
      // 存
      if (isPlainObject(value) || isArray(value) || isBoolean(value) || isUndefined(value) || isNull(null) || isSymbol(value)) {
        value = JSON.stringify(value)
      }
      localStorage.setItem(key, value)
    }
    return this
  }
}

Storage.fn.Init.prototype = Storage.fn

Storage.fn.extend = Storage.extend = function () {
  const argLen = arguments.length
  let target; const sources = []

  if (argLen === 0) return this
  if (argLen === 1) {
    target = this
    sources.push(arguments[0])
  } else {
    target = arguments[0]
    push.apply(sources, arguments)
    splice.call(sources, 0, 1)
  }

  for (let i = 0; i < sources.length; i++) {
    const source = sources[i]
    for (let key in source) {
      target[key] = source[key]
    }
  }
  // 返回结果
  return target
}

Storage.fn.extend({
  del: function () {
    const val = this.cacheKyes
    localStorage.removeItem(val)
    return this
  }
})

Storage.extend({
  del: function (val) {
    localStorage.removeItem(val)
    return this
  }
})
export default Storage
